<template>
	<div style="margin-top: -1rem;">
		<a-button size="small"   @click="doPrint" style="margin:0.425rem;" :disabled="isdoPrint" icon="printer">打印</a-button>
		<vxe-table  align="center" :data="chargePercentList"  border height="300"  ref="mTable" show-overflow="title" size="mini"
						  resizable highlight-hover-row :loading="loading"  row-id="pId" :cell-style="cellClassName">
						  <vxe-table-column type="seq" width="60"></vxe-table-column>
						  <vxe-table-column title="小区" field="n_name" ></vxe-table-column>
						  <vxe-table-column title="欠费户数" field="owecount"></vxe-table-column>
						  <vxe-table-column title="总用户数" field="allcount" ></vxe-table-column>
						  <vxe-table-column title="欠费金额" field="owebalance"></vxe-table-column>
						   <vxe-table-column title="应收金额" field="demoney"></vxe-table-column>
						   <vxe-table-column title="小区余额" field="balance"></vxe-table-column>
						   <vxe-table-column title="欠费用户比例" field="owerate" ></vxe-table-column>
						   <vxe-table-column title="收费率" field="chargerate"></vxe-table-column>
	    </vxe-table>					
		<div class="EchartCustomer">
        <div id="main"></div>
    </div>
		<div class="EchartMoney">
        <div id="main1"></div>
    </div>
	</div>
</template>

<script>
//  合并option数据
import _ from 'lodash';

export default{
	data(){
		return{
			isdoPrint:true,
	//需要合并的数据
			oweoption : {
				// color:['#009ad6'],
				title:{
					text:"户数"
				},
				grid:{
					height:400,
					width:1500,
					left:80
					// left: '3%',
        	// right: '4%',
        	// bottom: '3%',
				},
				tooltip:{},
				legend:{
					data:['欠费用户','正常用户']
				},
				xAxis:[{
					type : 'category',
					data : [''],
	      }],
				yAxis:[{
					name:"数量",
					type:'value'
				}],
				series:
				[{
					name:"欠费用户",
					type:"bar",
					stack:'户数',
					data:[0],
					barWidth : 20,
				},
				{
					name:"正常用户",
					type:"bar",
					stack:'户数',
					data:[0],
					barWidth : 20,
				}
			]
			},
			moneyoption : {
				title:{
					text:"金额"
				},
				grid:{
					height:400,
					width:1500,
					left:80
				},
				tooltip:{
					show : true
				},
				legend:{
					data : ['欠费金额','小区余额']
				},
				xAxis:[{
		            	type : 'category',
		            	data : ['']
		        }],
				yAxis:[{
					name:"数量",
					type:'value'
				}],
				series:[{
						name:"欠费金额",
						type:"bar",
						stack:'金额',
						data:[0],
						barWidth : 20,
					},
					{
						name:"小区余额",
						type:"bar",
						stack:'金额',
						data:[0],
						barWidth : 20,
					}
				]
			},
			chargePercentList:[],
			year:null,
			yearShowOne:false,
			loading:false,
		}
	},
	// name: "EchartCustomer",
	methods:{
		cellClassName({ row, rowIndex, column }){
			let style = {
				'color':'#000',
			}
			return style;
		},
		scrollSome:function(){
			this.$refs.mTable.refreshScroll();
		},
		doPhoto:function(){
        //初始化x,y轴数据
        this.oweoption.series[0].data=[];
        this.oweoption.series[1].data=[];
        this.oweoption.xAxis[0].data=[];
        this.moneyoption.xAxis[0].data=[];
				this.moneyoption.series[0].data=[];
				this.moneyoption.series[1].data=[];

				let userId = this.Config.getUserLocal().pId;
				let param = {userId:userId};
        let url = this.Api.getLastUrl(this.Api.Static_LIST_ChargePercentDraw_URL);

        this.Api.fetchPostWithForm(url,param).then((data) => {
					console.log("data.result");
					console.log(data);
          if (data.data.code == this.Api.HTTP_OK_CODE) {
						//用户
            data.data.result.owecounts.forEach(element => {
							this.oweoption.series[0].data.push(element);
						});
						data.data.result.allcounts.forEach(element => {
							this.oweoption.series[1].data.push(element);
						});
						data.data.result.n_names.forEach(element => {
							this.oweoption.xAxis[0].data.push(element);
							this.moneyoption.xAxis[0].data.push(element);
						});
						//金额
            data.data.result.owebalances.forEach(element => {
							this.moneyoption.series[0].data.push(element);
						});

						data.data.result.balances.forEach(element => {
							this.moneyoption.series[1].data.push(element);
						});
          }
          console.log(this.oweoption);
          console.log(this.moneyoption);
          this.drawChart(this.oweoption,this.moneyoption);
        }).catch((error) => {
          console.log(error);
        });
      },
		doPrint:function(){
			let url = this.Api.getLastUrl('/report/chargePercentReport');
			let userId = this.Config.getUserLocal().pId;
			window.open(url+'?userId='+userId, "_blank");
		},
		doQuery:function(){
			this.isdoPrint=true;
			this.chargePercentList=[];

			this.loading = true;
			let url = this.Api.getLastUrl(this.Api.Static_LIST_ChargePercent_URL);
			let userId = this.Config.getUserLocal().pId;
			let param = {userId:userId};
			this.Api.fetchPostWithForm(url,param).then((data)=>{
				this.loading = false;
				let code = data.data.code;
				let result = data.data.result;
				let msg = data.data.message;
				if(code == this.Api.HTTP_OK_CODE){
					this.chargePercentList = result;
					this.doPhoto();
					this.isdoPrint=false;
				}else{
					this.$message.error(msg);
				}
			}).catch((error)=>{
				console.log(error);
				this.loading = false;
			});
					
		},
		drawChart(oweoption,moneyoption) {
			//初始化大小
			let myEchart = this.$echarts.init(document.getElementById("main"));
			let myEchart1 = this.$echarts.init(document.getElementById("main1"));
			
			myEchart.setOption(oweoption);
			myEchart1.setOption(moneyoption);
		}
	},
	mounted() {
      this.drawChart(this.oweoption,this.moneyoption);
  },
	created(){
			this.doQuery();
	}
}
</script>

<style>
#main {
    width: 3000px;
    height:600px;
    /* margin: auto; */
		/* margin-left: 0.5px; */
    margin-top: 1.25rem
}
#main1 {
    width: 3000px;
    height:600px;
    /* margin: auto; */
		/* margin-left: 0.5px; */
    margin-top: 1.25rem
}

</style>